<ng-container *ngComponentOutlet="LoaderComponent">
</ng-container>

<div mat-dialog-title style="position: relative;">
    <p style="font-weight: bold; background-color: #efefef; color: #c89d07;padding: 8px;margin-top: -8px;
    margin-left: -24px;margin-right: -24px;">
        Format History
    </p>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close"
       (click)="onNoClick()" style="color: black; top: 0px;left: 580px;position: absolute;">
        <span aria-hidden="true" class="">&times;</span>
    </button>
</div>

<div mat-dialog-content class="dialog-content">
    <div *ngFor="let history of historyList" class="mb-3">
        <div class="row" *ngIf="history?.ViewedOn">
            <div class="col-md-3">Viewed on</div>
            <div class="col-md-1">:</div>
            <div class="col-md-8">{{history?.ViewedOn | date: 'dd/MM/yyyy'}}</div>
        </div>
        <div class="row" *ngIf="history?.EmployeeName">
            <div class="col-md-3">Employee</div>
            <div class="col-md-1">:</div>
            <div class="col-md-8">{{history?.EmployeeName}}</div>
        </div>
        <div class="row">
            <div class="col-md-3">Format Type</div>
            <div class="col-md-1">:</div>
            <div class="col-md-8">{{history?.FormatType}}</div>
        </div>
        <div class="row" *ngIf="history?.PrintDate">
            <div class="col-md-3">Printed on</div>
            <div class="col-md-1">:</div>
            <div class="col-md-8">{{history?.PrintDate | date: 'dd/MM/yyyy'}}</div>
        </div>
        <div class="row" *ngIf="history?.PrintDate">
            <div class="col-md-3">Print Reason</div>
            <div class="col-md-1">:</div>
            <div class="col-md-8">{{history?.PrintReason}}</div>
        </div>
    </div>
</div>